import { call, put, takeLatest } from "redux-saga/effects";
import {
  getCall,
  postMoveToshortlist,
} from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";
import {
  CHANGE_SHORTLIST_MANAGER,
  GET_SHORTLIST_DETAILS,
  GET_SHORTLIST_MANAGERS_LIST,
  UPDATE_SHORTLIST_DETAILS,
} from "./actionTypes";

import { showErrorMessage, showSuccessMessage } from "../../actions";
import {
  getShortlistDetailsFail,
  getShortlistDetailsSuccess,
  getShortlistManagerFailed,
  getShortlistManagerSuccess,
  updateShortlistDetailsFail,
  updateShortlistDetailsSuccess,
} from "./actions";

function* callShortDetailsAPI(data) {
  try {
    const { jobId, candidateId } = data.payload;
    let responseJSON = yield call(
      getCall,
      constClass.REST_API_GET_SHORTLIST_CANDIDATE_DATA,
      { jobId, candidateId },
    );

    if (responseJSON && typeof responseJSON === "object") {
      if ("success" in responseJSON) {
        if (responseJSON.success === false) {
          yield put(
            getShortlistDetailsFail({
              message: responseJSON.message || "Candidate not shortlisted yet",
              isNotFound: true,
            }),
          );
        } else if (responseJSON.success === true && responseJSON.data) {
          yield put(getShortlistDetailsSuccess(responseJSON.data));
        } else {
          yield put(
            getShortlistDetailsFail({
              message: "No shortlist data available",
              isNotFound: true,
            }),
          );
        }
      } else {
        // Legacy format support
        yield put(getShortlistDetailsSuccess(responseJSON));
      }
    } else {
      yield put(
        getShortlistDetailsFail({
          message: "No data received",
          isNotFound: true,
        }),
      );
    }
  } catch (error) {
    const errorString = String(error || "").toLowerCase();

    if (
      errorString.includes("404") ||
      errorString.includes("not found") ||
      errorString.includes("shortlist details not found") ||
      errorString.includes("candidate not shortlisted") ||
      errorString.includes("not been shortlisted")
    ) {
      yield put(
        getShortlistDetailsFail({
          message: "Candidate not shortlisted yet",
          isNotFound: true,
        }),
      );
    } else {
      yield put(getShortlistDetailsFail(error));
      yield put(showErrorMessage(error || "Failed to fetch shortlist details"));
    }
  }
}

function* getShortlistMangersListHandler({ payload: jobid }) {
  try {
    let responsJSON;

    if (jobid.jobid) {
      responsJSON = yield call(getCall, constClass.REST_API_GET_MANAGERS_LIST, {
        jobId: jobid.jobid,
      });
    } else {
      responsJSON = yield call(getCall, constClass.REST_API_GET_MANAGERS_LIST);
    }

    yield put(getShortlistManagerSuccess(responsJSON));
  } catch (error) {
    yield put(getShortlistManagerFailed(error));
    yield put(showErrorMessage(error || "Failed to fetch managers list"));
  }
}

function* updateShortlistManager({ payload: data }) {
  try {
    let responsJSON = yield call(
      postMoveToshortlist,
      constClass.REST_API_MOVE_TO_SHORTLIST,
      data.data,
    );

    yield put(
      showSuccessMessage(
        responsJSON.message || "Shortlist manager updated successfully",
      ),
    );
  } catch (error) {
    yield put(showErrorMessage(error || "Failed to update shortlist manager"));
  }
}

function* updateShortlistDetailsHandler({ payload: data }) {
  try {
    let responsJSON = yield call(
      postMoveToshortlist,
      constClass.REST_API_UPDATE_SHORTLIST,
      data,
    );

    yield put(updateShortlistDetailsSuccess(responsJSON));
    yield put(
      showSuccessMessage(
        responsJSON.message || "Candidate moved to interview successfully",
      ),
    );
  } catch (error) {
    yield put(updateShortlistDetailsFail(error));
    yield put(showErrorMessage(error || "Failed to update shortlist details"));
  }
}

function* shortlistSaga() {
  yield takeLatest(GET_SHORTLIST_DETAILS, callShortDetailsAPI);
  yield takeLatest(GET_SHORTLIST_MANAGERS_LIST, getShortlistMangersListHandler);
  yield takeLatest(CHANGE_SHORTLIST_MANAGER, updateShortlistManager);
  yield takeLatest(UPDATE_SHORTLIST_DETAILS, updateShortlistDetailsHandler);
}

export default shortlistSaga;
